<form *ngIf="airSearchCarrierForm">
        <div class="flex-column">
            <h2 class="form-title">{{ wording.includeExcludeCarriers }}</h2>
            <chips-field *ngIf="isInclude"
                [setMaj]="true"
                [group]="airSearchCarrierForm"
                [controlName]="carrierControlName.include"
                [excludeValue]="[]"></chips-field>
            <chips-field *ngIf="!isInclude"
                [setMaj]="true"
                [group]="airSearchCarrierForm"
                [controlName]="carrierControlName.exclude"
                [excludeValue]="[]"></chips-field>
        </div>
        <toggle 
            [isToggle]="isInclude"
            [label]="isInclude ? wording.include : wording.exclude"
            (toggleEvent)="toggleIncludeExclude()"></toggle>
        <div class="flex-column">
            <h2 class="form-title">{{ wording.preferredCarriers }}</h2>
            <chips-field
                [setMaj]="true"
                [group]="airSearchCarrierForm"
                [controlName]="carrierControlName.preferred"
                [excludeValue]="[]"></chips-field>
        </div>
</form>